import { FormResponseValueAnswer } from "@tellescope/types-models";

export const evaluateResponseEquals = (answer: FormResponseValueAnswer, comparison: string) => {
  if (answer.type === "Database Select" && answer.value?.length) {
    return !!answer.value.find((v) => v?.text === comparison);
  }

  if (answer.type === "Insurance") {
    return answer.value?.payerName === comparison;
  }

  if (answer.type === "Address") {
    return (
      comparison === answer.value?.state || comparison === answer.value?.zipCode || comparison === answer.value?.city
    );
  }

  return Array.isArray(answer.value) ? (answer.value as string[]).includes(comparison) : answer.value === comparison;
};
